import React from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { delimitNumber } from '@src/utils/number';
import pluralize from '@src/utils/pluralize';
import { StyledPackageV2 } from './index.style';
import RemainingCredits from './RemainingCredits';
import ExpDate from '../components/ExpDate';
import WarningAdvancedVoice from './WarningAdvancedVoice';

const PackageV2 = ({
  isLocked,
  credits,
  packageExpiryDate,
  isMobile,
  hasPreservationExpired,
  isFreePackage,
  isApiPackage,
  isCustomPackage,
  referralCredits,
}) => {
  const { i18n } = useTranslation();
  const { t, language } = i18n;

  const isExpiredPackage =
    packageExpiryDate && moment().isAfter(moment(packageExpiryDate));

  const showNoteWarningAdvancedVoice =
    !isApiPackage &&
    !isFreePackage &&
    !isCustomPackage &&
    !isExpiredPackage &&
    credits > 0;

  return (
    <StyledPackageV2>
      {(!hasPreservationExpired || isFreePackage) && (
        <>
          <RemainingCredits
            credits={`${delimitNumber(credits, language)} ${
              isMobile ? '' : pluralize(credits, t('credit'), language)
            }`}
            isLocked={isLocked}
            referralCredits={referralCredits}
          />
        </>
      )}
      <ExpDate packageExpiryDate={packageExpiryDate} />
      {showNoteWarningAdvancedVoice && <WarningAdvancedVoice />}
    </StyledPackageV2>
  );
};

export default PackageV2;
